import sectionsNames from './sectionsNames';

const sectionsMappings = {
  [sectionsNames.VIDEO]: [
    'Article_Sections_Sections_Video',
    'Page_Sections_Sections_Video',
    'Team_Sections_Sections_Video',
  ],
  [sectionsNames.TEXT]: [
    'Article_Sections_Sections_Text',
    'Page_Sections_Sections_Text',
    'Team_Sections_Sections_Text',
  ],
  [sectionsNames.CALL_TO_ACTION_FULLWIDTH]: [
    'Article_Sections_Sections_CallToActionFullwidth',
    'Page_Sections_Sections_CallToActionFullwidth',
    'Team_Sections_Sections_CallToActionFullwidth',
  ],
  [sectionsNames.TOP_THREE_TIPS]: [
    'Article_Sections_Sections_TopThreeTips',
    'Page_Sections_Sections_TopThreeTips',
    'Team_Sections_Sections_TopThreeTips',
  ],
  [sectionsNames.HELPFUL_GUIDES]: [
    'Article_Sections_Sections_HelpfulGuides',
    'Page_Sections_Sections_HelpfulGuides',
    'Team_Sections_Sections_HelpfulGuides',
  ],
  [sectionsNames.IMAGE]: [
    'Article_Sections_Sections_Image',
    'Page_Sections_Sections_Image',
    'Team_Sections_Sections_Image',
  ],
  [sectionsNames.CDF]: [
    'Article_Sections_Sections_Cdf',
    'Page_Sections_Sections_Cdf',
    'Team_Sections_Sections_Cdf',
  ],
  [sectionsNames.CALCULATOR]: [
    'Article_Sections_Sections_Calculator',
    'Page_Sections_Sections_Calculator',
    'Team_Sections_Sections_Calculator',
  ],
  [sectionsNames.QUOTE]: ['Team_Sections_Sections_Quote'],
  [sectionsNames.REVIEWIO]: ['Page_Sections_Sections_Reviewsio'],
  [sectionsNames.REVIEWS]: ['Page_Sections_Sections_Reviews'],
  [sectionsNames.QUESTIONS_ANSWERS]: ['Page_Sections_Sections_QuestionsSchema'],
  [sectionsNames.CTA_BUTTON]: ['Page_Sections_Sections_CtaButton'],
  [sectionsNames.BANNER]: ['Page_Sections_Sections_BannerSection'],
  [sectionsNames.FULLWIDTHREVIEW]: ['Page_Sections_Sections_FullWidthReview'],
  [sectionsNames.PRICE]: ['Page_Sections_Sections_Price'],
  [sectionsNames.REPRESENTATION]: ['Page_Sections_Sections_Representation'],
  [sectionsNames.ABOUT]: ['Page_Sections_Sections_About'],
  [sectionsNames.CLIENT]: ['Page_Sections_Sections_Client'],
  [sectionsNames.LAWYER]: ['Page_Sections_Sections_Lawyer'],
  [sectionsNames.TOOLS]: ['Page_Sections_Sections_Tools'],
  [sectionsNames.FAQ]: ['Page_Sections_Sections_Faq'],
  [sectionsNames.FEESBANNER]: ['Page_Sections_Sections_FeesBanner'],
  [sectionsNames.FEESPROCESS]: ['Page_Sections_Sections_FeesProcess'],
  [sectionsNames.FEESCALCULATE]: ['Page_Sections_Sections_FeesCalculate'],
  [sectionsNames.AWARD]: ['Page_Sections_Sections_Award'],
  [sectionsNames.TACTICS]: ['Page_Sections_Sections_Tactics'],
  [sectionsNames.TACTICSBANNER]: ['Page_Sections_Sections_TacticsBanner'],
  [sectionsNames.AUTOSCHEDULE]: ['Page_Sections_Sections_AutoSchedule'],
  [sectionsNames.BLOG]: ['Page_Sections_Sections_BlogSection'],
};

export default sectionsMappings;
